import { render, staticRenderFns } from "./tongzhiList.vue?vue&type=template&id=61308563&scoped=true"
import script from "./tongzhiList.vue?vue&type=script&lang=js"
export * from "./tongzhiList.vue?vue&type=script&lang=js"
import style0 from "./tongzhiList.vue?vue&type=style&index=0&id=61308563&prod&lang=scss"
import style1 from "./tongzhiList.vue?vue&type=style&index=1&id=61308563&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61308563",
  null
  
)

export default component.exports